module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mrescirp4-8a2311032f64f41a2f6ce5d01fef7e2d.jpg";